import { render, staticRenderFns } from "./CustomMessageText.vue?vue&type=template&id=4bdbcc16"
import script from "./CustomMessageText.vue?vue&type=script&lang=js"
export * from "./CustomMessageText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports